function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 31.52C24.5715 31.52 31.52 24.5714 31.52 16C31.52 7.42852 24.5715 0.47998 16 0.47998C7.42858 0.47998 0.480042 7.42852 0.480042 16C0.480042 24.5714 7.42858 31.52 16 31.52Z",
  fill: "url(#paint0_linear)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7921 22.184L17.5441 9.49602C17.2481 8.84002 16.8081 8.52002 16.2281 8.52002H15.7641C15.1841 8.52002 14.7441 8.84002 14.4481 9.49602L12.1641 15.024H10.4361C9.92006 15.028 9.50006 15.444 9.49606 15.964V15.976C9.50006 16.492 9.92006 16.912 10.4361 16.916H11.3641L9.18406 22.184C9.14406 22.3 9.12006 22.42 9.12006 22.544C9.12006 22.84 9.21206 23.072 9.37606 23.252C9.54006 23.432 9.77606 23.52 10.0721 23.52C10.2681 23.516 10.4561 23.456 10.6121 23.34C10.7801 23.224 10.8961 23.056 10.9881 22.864L13.3881 16.912H15.0521C15.5681 16.908 15.9881 16.492 15.9921 15.972V15.948C15.9881 15.432 15.5681 15.012 15.0521 15.008H14.1641L15.9961 10.444L20.9881 22.86C21.0801 23.052 21.1961 23.22 21.3641 23.336C21.5201 23.452 21.7121 23.512 21.9041 23.516C22.2001 23.516 22.4321 23.428 22.6001 23.248C22.7681 23.068 22.8561 22.836 22.8561 22.54C22.8601 22.42 22.8401 22.296 22.7921 22.184Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 27.5715,
  y1: 6.26344,
  x2: 4.47777,
  y2: 25.6945,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6509E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2EBAC6"
})));
function SvgTokenAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAave);
export default __webpack_public_path__ + "static/media/token-aave.042364c1ce8b4c8df185f97760cbcdd4.svg";
export { ForwardRef as ReactComponent };